<template>
  <ThankYouPage />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ThankYouPage from 'chimera/all/themes/blueflow/page/ThankYou/ThankYouPage'
import { clearFunnelEntered } from '~/middleware/VariantGuard.PD-10913'

export default {
  components: {
    ThankYouPage,
  },

  extends: AbstractPage,

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Aanvraag afgerond',
      headDescription:
        'Vul je postcode in en vergelijk geheel gratis 6 offertes van top makelaars uit jouw regio. ✓Dé beste prijs voor jouw makelaar ✓Bespaar tot 40% ✓100% Gratis!',
      path: '/offertes-aanvragen/aanvraag-afgerond',
    }
  },

  /**
   * Reset lead store so navigating back triggers FlowGuard redirect.
   */
  mounted() {
    this.$store.commit('lead/reset')
    clearFunnelEntered() // PD-10913: block back-button re-entry.
  },
}
</script>
